import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddLanguageLevels, LanguageLevels } from '../models/languagelevels/languagelevels';


@Injectable({
  providedIn: 'root'
})
export class LanguageLevelsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getLanguageLevels(LanguageLevelsId?: number): Observable<LanguageLevels[]>{
        return this._http.get<LanguageLevels[]>(`${environment.api.url}/LanguageLevels?LanguageLevelsId=${LanguageLevelsId??''}`);
    }
  
    public deleteLanguageLevels(LanguageLevelsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/LanguageLevels/${LanguageLevelsId}`);
    }
  
    public addLanguageLevels(model: AddLanguageLevels): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/LanguageLevels`, model);
    }
}
